import { BaseRequestsService } from '@/services/base-requests-service';

class ForgotPasswordRequests extends BaseRequestsService {

  /**
   * @async
   * @method
   * @param {Object} options
   * @param {string} options.username
   */
  forgot(options) {
    return this.http.post('v1/users/forgot-password', options);
  }

  /**
   * @async
   * @method
   * @param {Object} options
   * @param {string} options.token
   * @param {string} options.otp
   */
  confirm(options) {
    return this.http.post('v1/users/forgot-password/confirm', options);
  }

  /**
   * @async
   * @method
   * @param {Object} options
   * @param {string} options.token
   * @param {string} options.password
   */
  reset(options) {
    return this.http.post('v1/users/forgot-password/reset-password', options);
  }

}

const forgotPasswordRequests = new ForgotPasswordRequests();
export { forgotPasswordRequests as ForgotPasswordRequests };
